import { baseUrl } from "../config/config";
import axios from 'axios';

// get all Vavaka
export const getAllVavaka = async () => {
  try {
    const response = await axios.get(`${baseUrl}/vavaka`);
    return response.data;
  } catch (error) {
    console.error('erreur get all Vavaka:', error);
    return error;
  }
}

// get Vavaka by Id
export const getVavakaById = async (id) => {
  try {
    const response = await axios.get(`${baseUrl}/vavaka/${id}`);
    return response.data;
  } catch (error) {
    console.error(`erreur get Vavaka by Id ${id}:`, error);
    return error;
  }
}

// add Vavaka
export const addVavaka = async (vavaka) => {
  try {
    const response = await axios.post(`${baseUrl}/vavaka`, vavaka);
    return response;
  } catch (error) {
    return error;
  }
}

// update Vavaka by Id
export const updateVavakaById = async (id, vavaka) => {
  try {
    const response = await axios.patch(`${baseUrl}/vavaka/${id}`, vavaka, {
      headers:{
        'Cache-Control':'no-cache'
      }
    });
    return response;
  } catch (error) {
    console.error(`erreur lors de la modification du Vavaka by id ${id}:`, error);
    return error;
  }
}

// delete Vavaka by Id
export const deleteVavakaById = async (id) => {
  try {
    const response = await axios.delete(`${baseUrl}/vavaka/${id}`);
    return response;
  } catch (error) {
    console.error(`erreur lors de la supression du Vavaka ${id}:`, error);
    return error;
  }
}
